  // Check the width when the window is resized
window.addEventListener('resize', function () {
  // Get the current window width
  var windowWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;

  // Check if the width is less than 990
  if (windowWidth < 990) {
    // Select and remove the element with class "cart-box"
    var cartBoxElement = document.querySelector('a.cart-box.de');
    if (cartBoxElement) {
      cartBoxElement.remove();
    }
  }
});

// Trigger the check on initial page load
window.dispatchEvent(new Event('resize'));


$(document).on("click",".quantity__button",function() {
    $("button.quantity__button").removeClass('yes');
    $(this).addClass('yes');
    // alert('yes');
});


class CartRemoveButton extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('click', async (event) => {
      event.preventDefault();
      const dataIds = this.dataset.ids;
      const cartItems = this.closest('cart-items') || this.closest('cart-drawer-items');
      var Indexdata = this.dataset.index;
       // const itemIndex = await this.findCartItemIndex(cleansplitIds[0]);
      const cleansplitIds = dataIds.split("22195i00j55623").filter(id => id.trim() !== ''); // Filter out empty or whitespace-only IDs
      await this.clearCart(cleansplitIds,Indexdata);
      loaddiscount();
    });
  }

async clearCart(ids,Indexdata) {
  const updates = {};
  for (let i = 1; i < ids.length; i++) {
    updates[ids[i]] = 0; // Set quantity for each item
  }
  try {
    const response = await jQuery.post(window.Shopify.routes.root + 'cart/update.js', {
      updates: updates
    });
    console.log('Cart updated:', response);

    // Added console message after successfully updating cart quantities
    console.log('All IDs updated successfully.');
    const cartItems = this.closest('cart-items') || this.closest('cart-drawer-items');
   // alert();
    cartItems.updateQuantity(Indexdata, 0);
  } catch (error) {
    console.error('Error updating cart:', error);
  }
}


  removeDuplicates(arr) {
    return arr.filter((value, index, self) => self.indexOf(value) === index);
  }

  async findCartItemIndex(key) {
    try {
      const cart = await jQuery.getJSON(window.Shopify.routes.root + 'cart.js');
      const items = cart.items;
      for (let i = 0; i < items.length; i++) {
        if (items[i].key === key) {
          return i + 1;
        }
      }
      return -1; // Key not found in the cart
    } catch (error) {
      console.error(error);
      return -1; // Error occurred while fetching cart
    }
  }

  delay(ms) {
    return new Promise(resolve => setTimeout(resolve, ms));
  }

  async myAsyncFunction(ids) {
    const cleansplitIds = ids;
    const filteredArray = cleansplitIds.filter(item => item !== '');
    const removefilteredArray = this.removeDuplicates(filteredArray);

    const processItemAtIndex = async (index) => {
      try {
        const itemIndex = await this.findCartItemIndex(removefilteredArray[index]);
        console.log("Index:", itemIndex);
        const cartItems = this.closest('cart-items') || this.closest('cart-drawer-items');
        await cartItems.updateQuantity(itemIndex, 0);
      } catch (error) {
        console.error("Error:", error);
      }
    };

    // Process all items with a delay between each item
    for (let i = 0; i < removefilteredArray.length; i++) {
      await processItemAtIndex(i);
      await this.delay(1300); // Wait for 1.3 seconds before processing the next item
    }
  }

}

customElements.define('cart-remove-button', CartRemoveButton);


class CartItems extends HTMLElement {
  constructor() {
    super();
    this.lineItemStatusElement = document.getElementById('shopping-cart-line-item-status') || document.getElementById('CartDrawer-LineItemStatus');
    this.currentItemCount = Array.from(this.querySelectorAll('[name="updates[]"]'))
    .reduce((total, quantityInput) => total + parseInt(quantityInput.value), 0);
    this.debouncedOnChange = debounce((event) => {
      const cartRemoveButton = event.target.closest('.cart-item__quantity-wrapper').querySelector('cart-remove-button');
      const dataIdsAttribute = cartRemoveButton.getAttribute('data-ids');
      const updateFirstIndex = event.target.dataset.index;
      const updateFirstIndexQty= event.target.value;
      const qtysDiv = event.target.closest('.cart-item__quantity');
      var updateFirstIndexName= document.activeElement.getAttribute('name');
    const qtysValue = qtysDiv.getAttribute('data-randomstring');
    

     if (updateFirstIndexName === null) {
          
          updateFirstIndexName = $('button.quantity__button.no-js-hidden.yes').attr("name");
        }
      
      if(dataIdsAttribute)
      {
        this.myAsyncUpdateFunction(dataIdsAttribute,updateFirstIndex,updateFirstIndexQty,updateFirstIndexName,qtysValue);
      }
      else
      {
      this.onChange(event);
     }
    }, 300);
    this.addEventListener('change', this.debouncedOnChange.bind(this));
  }
async clearCartUpdate(ids,Indexdata) {
  const updates = {};
  for (let i = 1; i < ids.length; i++) {
       const cartItemsGet = await this.findCartItemIndexUpdate(removefilteredArray[index]);
          const cartItems = this.closest('cart-items') || this.closest('cart-drawer-items');
           const itemIndex = cartItemsGet.index;
          const itemQty = cartItemsGet.quantity;
        updates[ids[i]] = 0; // Set quantity for each item
  }
  try {
    const response = await jQuery.post(window.Shopify.routes.root + 'cart/update.js', {
      updates: updates
    });
    console.log('Cart updated:', response);

    // Added console message after successfully updating cart quantities
    console.log('All IDs updated successfully.');
    const cartItems = this.closest('cart-items') || this.closest('cart-drawer-items');
   // alert();
    cartItems.updateQuantity(Indexdata, 0);
  } catch (error) {
    console.error('Error updating cart:', error);
  }
}
  findCartItemIndexUpdate(key) {
  return new Promise((resolve, reject) => {
    jQuery.getJSON(window.Shopify.routes.root + 'cart.js')
      .done(function(cart) {
        const items = cart.items;
        for (let k = 0; k < items.length; k++) {
          if (items[k].key === key) {
            const itemQty = items[k].quantity;
            const cartItem = { index: k + 1, quantity: itemQty };
            resolve(cartItem);
            return;
          }
        }
        reject(new Error("Key not found in the cart."));
      })
      .fail(function(jqxhr, textStatus, error) {
        reject(new Error(error));
      });
  });
}
 
removeDuplicates(arr) {
  return arr.filter((value, index, self) => self.indexOf(value) === index);
}
async myAsyncUpdateFunction(ids=0, updateFirstIndex, updateFirstIndexQty, updateFirstIndexName,qtysValue) {
  const cleansplitIds = ids.split("22195i00j55623");
  var filteredArray = cleansplitIds.filter(item => item !== '');
    const removefilteredArray = filteredArray;
 //  const removefilteredArray = this.removeDuplicates(filteredArray);
   let index = 0;
   const updates = {};
      try {
           const cartItemsGet = await this.findCartItemIndexUpdate(removefilteredArray[0]);
          const cartItems = this.closest('cart-items') || this.closest('cart-drawer-items');
           const itemIndex = cartItemsGet.index;
          const itemQty = cartItemsGet.quantity;
           var textArray = $(`span.qty[data-randomstring="${qtysValue}"]`).map(function() {
            return $(this).text();
        }).get();
        if(updateFirstIndexName=="plus")
        {
             if (removefilteredArray.length == 1) 
             {
               try {
                       this.updateQuantity(updateFirstIndex, updateFirstIndexQty,updateFirstIndexName);
                   } catch (error) {
                              console.error('Error updating cart:', error);
                   }
             }
              if (removefilteredArray.length == 3) 
             {
                    const qtyArrayLength = textArray.length;
                    if(qtyArrayLength==2)
                    {
                      var updatedNextQty = textArray[0];
                      var updatedNextQty2 = textArray[1];
                      if(updatedNextQty > updatedNextQty2)
                      {
                        updatedNextQty2 = parseInt(updatedNextQty2)+1;
                        updatedNextQty = parseInt(updatedNextQty)+2;
                      }
                      else if(updatedNextQty==updatedNextQty2)
                      {
                        updatedNextQty2 = parseInt(updatedNextQty2)+1;
                        updatedNextQty = parseInt(updatedNextQty)+1;
                      }
                      else
                      {
                        updatedNextQty2 = parseInt(updatedNextQty2)+2;
                        updatedNextQty = parseInt(updatedNextQty)+1;
                      }
                         updates[filteredArray[1]] = updatedNextQty;
                         updates[filteredArray[2]] = updatedNextQty2;
                     try {
                        const response = await jQuery.post(window.Shopify.routes.root + 'cart/update.js', {
                          updates: updates
                        });
                        console.log('Cart updated:', response);
                        console.log('All IDs updated successfully.');
                        this.updateQuantity(updateFirstIndex, updateFirstIndexQty,updateFirstIndexName);
                      } catch (error) {
                        console.error('Error updating cart:', error);
                      }  
                    }
              }
          if(removefilteredArray.length == 2) 
             {
              // alert("There is two values");
                    const qtyArrayLength = textArray.length;
                    //alert("There is two values"+qtyArrayLength);
                    if(qtyArrayLength==1)
                    {
                      // alert("There is two values sdsdsds");
                      var updatedNextQty = textArray[0];
                      //var updatedNextQty2 = textArray[1];
                        if(updatedNextQty > updateFirstIndexQty)
                          {
                            //alert(updatedNextQty);
                            // alert(updateFirstIndexQty);
                                  if ((updatedNextQty == 3 && updateFirstIndexQty == 2) ||
                                  (updatedNextQty == 6 && updateFirstIndexQty == 3) ||
                                  (updatedNextQty == 9 && updateFirstIndexQty == 4) ||
                                  (updatedNextQty == 12 && updateFirstIndexQty == 5) ||
                                  (updatedNextQty == 15 && updateFirstIndexQty == 6) ||
                                  (updatedNextQty == 18 && updateFirstIndexQty == 7) ||
                                  (updatedNextQty == 21 && updateFirstIndexQty == 8) ||
                                  (updatedNextQty == 24 && updateFirstIndexQty == 9) ||
                                  (updatedNextQty == 27 && updateFirstIndexQty == 10) ||
                                  (updatedNextQty == 30 && updateFirstIndexQty == 11)) 
                                  {
                                    //alert("sdsd"+updateFirstIndexQty);
                                    updatedNextQty = parseInt(updatedNextQty)+3;
                                    //updates[filteredArray[0]] = updateFirstIndexQty;
                                    updates[filteredArray[1]] = updatedNextQty;
                                 }
                                 else if((updatedNextQty == 2 && updateFirstIndexQty == 2) ||
                                  (updatedNextQty == 4 && updateFirstIndexQty == 3) ||
                                  (updatedNextQty == 6 && updateFirstIndexQty == 4) ||
                                  (updatedNextQty == 8 && updateFirstIndexQty == 5) ||
                                  (updatedNextQty == 10 && updateFirstIndexQty == 6) ||
                                  (updatedNextQty == 12 && updateFirstIndexQty == 7) ||
                                  (updatedNextQty == 14 && updateFirstIndexQty == 8) ||
                                  (updatedNextQty == 16 && updateFirstIndexQty == 9) ||
                                  (updatedNextQty == 18 && updateFirstIndexQty == 10) ||
                                  (updatedNextQty == 20 && updateFirstIndexQty == 11) ||
                                  (updatedNextQty == 22 && updateFirstIndexQty == 12))
                                  {
                                      //alert("sdsd2222"+updatedNextQty);
                                       updatedNextQty = parseInt(updatedNextQty)+2;
                                     // updates[filteredArray[0]] = updateFirstIndexQty;
                                      updates[filteredArray[1]] = updatedNextQty;
                                  }
                                 else
                                  {
                                    updatedNextQty = parseInt(updatedNextQty)+3;
                                   // updates[filteredArray[0]] = updateFirstIndexQty;
                                    updates[filteredArray[1]] = updatedNextQty;
                                 }
                          }
                         else if(updateFirstIndexQty > updatedNextQty)
                          {
                              updatedNextQty = parseInt(updateFirstIndexQty);
                              // updates[filteredArray[0]] = updateFirstIndexQty;
                              updates[filteredArray[1]] = updatedNextQty;
                          }
                         else if((updatedNextQty == 2 && updateFirstIndexQty == 2) ||
                                  (updatedNextQty == 4 && updateFirstIndexQty == 3) ||
                                  (updatedNextQty == 6 && updateFirstIndexQty == 4) ||
                                  (updatedNextQty == 8 && updateFirstIndexQty == 5) ||
                                  (updatedNextQty == 10 && updateFirstIndexQty == 6) ||
                                  (updatedNextQty == 12 && updateFirstIndexQty == 7) ||
                                  (updatedNextQty == 14 && updateFirstIndexQty == 8) ||
                                  (updatedNextQty == 16 && updateFirstIndexQty == 9) ||
                                  (updatedNextQty == 18 && updateFirstIndexQty == 10) ||
                                  (updatedNextQty == 20 && updateFirstIndexQty == 11) ||
                                  (updatedNextQty == 22 && updateFirstIndexQty == 12))
                           {
                               updatedNextQty = parseInt(updatedNextQty)+2;
                               //updates[filteredArray[0]] = updateFirstIndexQty;
                              updates[filteredArray[1]] = updatedNextQty;
                          }
                     
                     try {
                        const response = await jQuery.post(window.Shopify.routes.root + 'cart/update.js', {
                          updates: updates
                        });
                        console.log('Cart updated:', response);
                        console.log('All IDs updated successfully.');
                        this.updateQuantity(updateFirstIndex, updateFirstIndexQty,updateFirstIndexName);
                      } catch (error) {
                        console.error('Error updating cart:', error);
                      }  
                    }
              }
            if(removefilteredArray.length == 4) 
             {
             //  alert("There is four values");
                    const qtyArrayLength = textArray.length;
                    if(qtyArrayLength==3)
                    {
                         updates[filteredArray[1]] = updateFirstIndexQty;
                         updates[filteredArray[2]] = updateFirstIndexQty;
                         updates[filteredArray[3]] = updateFirstIndexQty;
                     try {
                        const response = await jQuery.post(window.Shopify.routes.root + 'cart/update.js', {
                          updates: updates
                        });
                        console.log('Cart updated:', response);
                        console.log('All IDs updated successfully.');
                        this.updateQuantity(updateFirstIndex, updateFirstIndexQty,updateFirstIndexName);
                      } catch (error) {
                        console.error('Error updating cart:', error);
                      }  
                    }
              }
        }
        else if(updateFirstIndexName=="minus")
        {
           if (removefilteredArray.length == 1) 
             {
               try {
                       this.updateQuantity(updateFirstIndex, updateFirstIndexQty,updateFirstIndexName);
                   } catch (error) {
                              console.error('Error updating cart:', error);
                   }
             }
         
          if (removefilteredArray.length == 4) 
             {
             //  alert("There is four values");
                    const qtyArrayLength = textArray.length;
                    if(qtyArrayLength==3)
                    {
                         updates[filteredArray[1]] = updateFirstIndexQty;
                         updates[filteredArray[2]] = updateFirstIndexQty;
                         updates[filteredArray[3]] = updateFirstIndexQty;
                     try {
                        const response = await jQuery.post(window.Shopify.routes.root + 'cart/update.js', {
                          updates: updates
                        });
                        console.log('Cart updated:', response);
                        console.log('All IDs updated successfully.');
                        this.updateQuantity(updateFirstIndex, updateFirstIndexQty,updateFirstIndexName);
                      } catch (error) {
                        console.error('Error updating cart:', error);
                      }  
                    }
              }
           if(removefilteredArray.length == 2) 
             {
                   const newValueFirstIndexQty = updateFirstIndexQty;
                    const qtyArrayLength = textArray.length;
                    if(qtyArrayLength==1)
                    {
                      //alert(newValueFirstIndexQty);
                         var updatedNextQty = textArray[0];
                          if(updatedNextQty > newValueFirstIndexQty)
                          {
                           //  alert("33");
                                  if((updatedNextQty == 3 && newValueFirstIndexQty == 0) ||
                                  (updatedNextQty == 6 && newValueFirstIndexQty == 1) ||
                                  (updatedNextQty == 9 && newValueFirstIndexQty == 2) ||
                                  (updatedNextQty == 12 && newValueFirstIndexQty == 3) ||
                                  (updatedNextQty == 15 && newValueFirstIndexQty == 4) ||
                                  (updatedNextQty == 18 && newValueFirstIndexQty == 5) ||
                                  (updatedNextQty == 21 && newValueFirstIndexQty == 6) ||
                                  (updatedNextQty == 24 && newValueFirstIndexQty == 7) ||
                                  (updatedNextQty == 27 && newValueFirstIndexQty == 8) ||
                                  (updatedNextQty == 30 && newValueFirstIndexQty == 9)) 
                                  {
                                    //alert("33");
                                    updatedNextQty = parseInt(updatedNextQty)-3;
                                    //updates[filteredArray[0]] = newValueFirstIndexQty;
                                    updates[filteredArray[1]] = updatedNextQty;
                                 }
                               else if((updatedNextQty == 1 && newValueFirstIndexQty == 0) ||
                                  (updatedNextQty == 2 && newValueFirstIndexQty == 1) ||
                                  (updatedNextQty == 3 && newValueFirstIndexQty == 2) ||
                                  (updatedNextQty == 4 && newValueFirstIndexQty == 3) ||
                                  (updatedNextQty == 5 && newValueFirstIndexQty == 4) ||
                                  (updatedNextQty == 6 && newValueFirstIndexQty == 5) ||
                                  (updatedNextQty == 7 && newValueFirstIndexQty == 6) ||
                                  (updatedNextQty == 8 && newValueFirstIndexQty == 7) ||
                                  (updatedNextQty == 9 && newValueFirstIndexQty == 8) ||
                                  (updatedNextQty == 10 && newValueFirstIndexQty == 9) ||
                                  (updatedNextQty == 11 && newValueFirstIndexQty == 10))
                                  {
                                       updatedNextQty = parseInt(updatedNextQty)-1;
                                      //updates[filteredArray[0]] = newValueFirstIndexQty;
                                      updates[filteredArray[1]] = updatedNextQty;
                                  }
                                  else if((updatedNextQty == 2 && newValueFirstIndexQty == 0) ||
                                  (updatedNextQty == 4 && newValueFirstIndexQty == 1) ||
                                  (updatedNextQty == 6 && newValueFirstIndexQty == 2) ||
                                  (updatedNextQty == 8 && newValueFirstIndexQty == 3) ||
                                  (updatedNextQty == 10 && newValueFirstIndexQty == 4) ||
                                  (updatedNextQty == 12 && newValueFirstIndexQty == 5) ||
                                  (updatedNextQty == 14 && newValueFirstIndexQty == 6) ||
                                  (updatedNextQty == 16 && newValueFirstIndexQty == 7) ||
                                  (updatedNextQty == 18 && newValueFirstIndexQty == 8) ||
                                  (updatedNextQty == 20 && newValueFirstIndexQty == 9) ||
                                  (updatedNextQty == 22 && newValueFirstIndexQty == 10))
                                  {
                                       updatedNextQty = parseInt(updatedNextQty)-2;
                                     // updates[filteredArray[0]] = newValueFirstIndexQty;
                                        updates[filteredArray[1]] = updatedNextQty;
                                  }
                                 else
                                  {
                                    updatedNextQty = parseInt(updatedNextQty)-3;
                                    //updates[filteredArray[0]] = newValueFirstIndexQty;
                                    updates[filteredArray[1]] = updatedNextQty;
                                  }
                          }
                          else if(newValueFirstIndexQty > updatedNextQty)
                          {
                              updatedNextQty = parseInt(newValueFirstIndexQty);
                               //updates[filteredArray[0]] = newValueFirstIndexQty;
                              updates[filteredArray[1]] = updatedNextQty;
                          }
                          else if((updatedNextQty == 2 && newValueFirstIndexQty == 0) ||
                                  (updatedNextQty == 4 && newValueFirstIndexQty == 1) ||
                                  (updatedNextQty == 6 && newValueFirstIndexQty == 2) ||
                                  (updatedNextQty == 8 && newValueFirstIndexQty == 3) ||
                                  (updatedNextQty == 10 && newValueFirstIndexQty == 4) ||
                                  (updatedNextQty == 12 && newValueFirstIndexQty == 5) ||
                                  (updatedNextQty == 14 && newValueFirstIndexQty == 6) ||
                                  (updatedNextQty == 16 && newValueFirstIndexQty == 7) ||
                                  (updatedNextQty == 18 && newValueFirstIndexQty == 8) ||
                                  (updatedNextQty == 20 && newValueFirstIndexQty == 9) ||
                                  (updatedNextQty == 22 && newValueFirstIndexQty == 10))
                          {
                               updatedNextQty = parseInt(updatedNextQty)-2;
                              // updates[filteredArray[0]] = newValueFirstIndexQty;
                               updates[filteredArray[1]] = updatedNextQty;
                          }
                              
                         try {
                            const response = await jQuery.post(window.Shopify.routes.root + 'cart/update.js', {
                              updates: updates
                            });
                            console.log('Cart updated:', response);
                            console.log('All IDs updated successfully.');
                            this.updateQuantity(updateFirstIndex, updateFirstIndexQty,updateFirstIndexName);
                          
                          } catch (error) {
                            console.error('Error updating cart:', error);
                          }  
                    }
              }
           if (removefilteredArray.length == 3) 
             {
                    const qtyArrayLength = textArray.length;
                    if(qtyArrayLength==2)
                    {
                      var updatedNextQty = textArray[0];
                      var updatedNextQty2 = textArray[1];
                      if(updatedNextQty > updatedNextQty2)
                      {
                        updatedNextQty2 = parseInt(updatedNextQty2)-1;
                        updatedNextQty = parseInt(updatedNextQty)-2;
                      }
                      else if(updatedNextQty==updatedNextQty2)
                      {
                        updatedNextQty2 = updateFirstIndexQty;
                        updatedNextQty = updateFirstIndexQty;
                      }
                      else
                      {
                        updatedNextQty2 = parseInt(updatedNextQty2)-2;
                        updatedNextQty = parseInt(updatedNextQty)-1;
                      }
                         updates[filteredArray[1]] = updatedNextQty;
                         updates[filteredArray[2]] = updatedNextQty2;
                     try {
                        const response = await jQuery.post(window.Shopify.routes.root + 'cart/update.js', {
                          updates: updates
                        });
                        console.log('Cart updated:', response);
                        console.log('All IDs updated successfully.');
                        this.updateQuantity(updateFirstIndex, updateFirstIndexQty,updateFirstIndexName);
                      } catch (error) {
                        console.error('Error updating cart:', error);
                      }  
                    }
              }
        }
      } catch (error) {
        //this.updateQuantity(updateFirstIndex,updateFirstIndexQty,updateFirstIndexName);
        console.error("Error:", error);
       
       
      }
    


}

  
  onChange(event) {
    this.updateQuantity(event.target.dataset.index, event.target.value,document.activeElement.getAttribute('name'));
  }
  getSectionsToRender() {
    return [
      {
        id: 'main-cart-items',
        section: document.getElementById('main-cart-items').dataset.id,
        selector: '.js-contents',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section'
      },
      {
        id: 'cart-live-region-text',
        section: 'cart-live-region-text',
        selector: '.shopify-section'
      },
      {
        id: 'main-cart-footer',
        section: document.getElementById('main-cart-footer').dataset.id,
        selector: '.js-contents',
      }
    ];
  }

  updateQuantity(line, quantity, name) {
    this.enableLoading(line);
    const body = JSON.stringify({
      line,
      quantity,
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname
    });

    fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        const parsedState = JSON.parse(state);
        this.classList.toggle('is-empty', parsedState.item_count === 0);
        const cartDrawerWrapper = document.querySelector('cart-drawer');
        const cartFooter = document.getElementById('main-cart-footer');
        if (cartFooter) cartFooter.classList.toggle('is-empty', parsedState.item_count === 0);
        if (cartDrawerWrapper) cartDrawerWrapper.classList.toggle('is-empty', parsedState.item_count === 0);
        this.getSectionsToRender().forEach((section => {
          const elementToReplace =
            document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
          elementToReplace.innerHTML =
            this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);
        }));
        this.updateLiveRegions(line, parsedState.item_count);
        const lineItem = document.getElementById(`CartItem-${line}`) || document.getElementById(`CartDrawer-Item-${line}`);
        if (lineItem && lineItem.querySelector(`[name="${name}"]`)) {
          cartDrawerWrapper ? trapFocus(cartDrawerWrapper, lineItem.querySelector(`[name="${name}"]`)) : lineItem.querySelector(`[name="${name}"]`).focus();
        } else if (parsedState.item_count === 0 && cartDrawerWrapper) {
          trapFocus(cartDrawerWrapper.querySelector('.drawer__inner-empty'), cartDrawerWrapper.querySelector('a'))
        } else if (document.querySelector('.cart-item') && cartDrawerWrapper) {
          trapFocus(cartDrawerWrapper, document.querySelector('.cart-item__name'))
        }
        this.disableLoading();
      }).catch(() => {
        this.querySelectorAll('.loading-overlay').forEach((overlay) => overlay.classList.add('hidden'));
        const errors = document.getElementById('cart-errors') || document.getElementById('CartDrawer-CartErrors');
        errors.textContent = window.cartStrings.error;
        this.disableLoading();
      });
    loaddiscount();
  }

  updateLiveRegions(line, itemCount) {
    if (this.currentItemCount === itemCount) {
      const lineItemError = document.getElementById(`Line-item-error-${line}`) || document.getElementById(`CartDrawer-LineItemError-${line}`);
      const quantityElement = document.getElementById(`Quantity-${line}`) || document.getElementById(`Drawer-quantity-${line}`);
      lineItemError
        .querySelector('.cart-item__error-text')
        .innerHTML = window.cartStrings.quantityError.replace(
          '[quantity]',
          quantityElement.value
        );
    }

    this.currentItemCount = itemCount;
    this.lineItemStatusElement.setAttribute('aria-hidden', true);
    const cartStatus = document.getElementById('cart-live-region-text') || document.getElementById('CartDrawer-LiveRegionText');
    cartStatus.setAttribute('aria-hidden', false);
    setTimeout(() => {
      cartStatus.setAttribute('aria-hidden', true);
    }, 1000);
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }

  enableLoading(line) {
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    mainCartItems.classList.add('cart__items--disabled');

    const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading-overlay`);
    const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .loading-overlay`);

    [...cartItemElements, ...cartDrawerItemElements].forEach((overlay) => overlay.classList.remove('hidden'));

    document.activeElement.blur();
    this.lineItemStatusElement.setAttribute('aria-hidden', false);
  }

  disableLoading() {
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    mainCartItems.classList.remove('cart__items--disabled');
  }
}

customElements.define('cart-items', CartItems);

if (!customElements.get('cart-note')) {
  customElements.define('cart-note', class CartNote extends HTMLElement {
    constructor() {
      super();

      this.addEventListener('change', debounce((event) => {
        const body = JSON.stringify({ note: event.target.value });
        fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } });
      }, 300))
    }
  });
};
